var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"map-container"}},[_c('div',{staticClass:"hide-from-print",attrs:{"id":"map"}}),_vm._v(" "),_c('div',{staticClass:"not-for-navigation"},[_vm._v(_vm._s(_vm.t('map_navigation_disclaimer')))])])}
var staticRenderFns = []

export { render, staticRenderFns }